export default "/temp.a225153c-d87010.svg";